import { HttpClient, IHttpClientResponse } from "app/core/http";
import { IHttpClientData } from "./types";
import { TOKEN_EXPIRED, UNAUTHORISEDUSER } from "./types/messages";
import { AuthService } from "./controllers/auth";

export class DefaultAPI {
    protected httpClient!: HttpClient;
    public auth: AuthService;

    constructor(baseURL: string) {
        this.httpClient = new HttpClient(baseURL);
        this.httpClient.setResponseInterceptor((response: IHttpClientResponse) => {
            response.json = (): IHttpClientData => this.getIHttpClientData(response);
            return response;
        }, (error: any) => error);

        // All the service are initialize
        this.auth = new AuthService(this.httpClient);
    }

    protected getIHttpClientData(response: IHttpClientResponse): IHttpClientData {
        const IHttpClientData: IHttpClientData = {
            code: null, message: null, data: null,
            status: null, isUnauthorized: false
        };

        if (response && typeof response === "object") {
            const data: any = response.data;
            IHttpClientData.status = data.status;
            IHttpClientData.code = data.code;
            IHttpClientData.message = data.message;
            IHttpClientData.data = data.data;
            IHttpClientData.isUnauthorized = ([TOKEN_EXPIRED.code, UNAUTHORISEDUSER.code]
                .indexOf(data.code) >= 0);
        }

        return IHttpClientData;
    }
}
